import {
	HttpClient,
	HttpContext
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BYPASS_LOG } from '@core/interceptors/loading-screen.interceptor';
import { ObjectMapper } from 'json-object-mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { SKIP_ERROR_INTERCEPTOR } from '@core/interceptors/error.interceptor';

@Injectable()
export class HttpService {
	protected baseUrl: URL = new URL(environment.apiUrl);

	constructor(private http: HttpClient) { }

	public changBaseUrl(url: string) {
		if (url) this.baseUrl = new URL(url);
	}

	public get(
		uri: string,
		options?: any,
		baseUrl?: string,
		bodyParams?: any,
		disableLoanding = false
	): Observable<any> {
		const opt = options
			? {
				...options,
				observe: 'response',
				context: new HttpContext().set(BYPASS_LOG, disableLoanding),
			}
			: {
				observe: 'response',
				context: new HttpContext().set(BYPASS_LOG, disableLoanding),
			};

		if (bodyParams) opt['params'] = ObjectMapper.serialize(bodyParams);

		return new Observable<any>((observer) => {
			const subscription = this.http
				.get(this.getEndpoint(uri, baseUrl), opt)
				.subscribe(
					(response) => {
						observer.next(response);
						observer.complete();
					},
					(err) => observer.error(err)
				);

			return () => subscription.unsubscribe();
		});
	}

	public post(
		uri: string,
		params: any,
		options?: any,
		baseUrl?: string,
		disableLoanding: boolean = false,
		skipErrorInterceptor: boolean = false
	): Observable<any> {
		let body: any = null;
		if (typeof params === 'string') {
			body = params;
		} else {
			this.convertTimes(params);
			body = ObjectMapper.serialize(params);
			body = body.length > 1 ? body : params.toJSON();
		}
		return new Observable<any>((observer) => {
			const url = baseUrl ? `${baseUrl}${uri}` : this.getEndpoint(uri);

			const opt = options
				? {
					...options,
					context: new HttpContext().set(BYPASS_LOG, disableLoanding).set(SKIP_ERROR_INTERCEPTOR, skipErrorInterceptor),
				}
				: {
					context: new HttpContext().set(BYPASS_LOG, disableLoanding).set(SKIP_ERROR_INTERCEPTOR, skipErrorInterceptor),
				};

			const subscription = this.http.post(url, body, opt).subscribe(
				(response) => {
					observer.next(response);
					observer.complete();
				},
				(err) => {
					observer.error(err);
				}
			);

			return () => subscription.unsubscribe();
		});
	}

	public put(
		uri: string,
		params: any,
		disableLoanding: boolean = false,
		skipErrorInterceptor: boolean = false
	): Observable<Response> {
		const opt = {
			context: new HttpContext()
				.set(BYPASS_LOG, disableLoanding)
				.set(SKIP_ERROR_INTERCEPTOR, skipErrorInterceptor),
		};

		return new Observable<any>((observer) => {
			const subscription = this.http
				.put(this.getEndpoint(uri), JSON.stringify(params), opt)
				.pipe(map((response) => response))
				.subscribe((response) => {
					observer.next(response);
					observer.complete();
				},
					(err) => {
						observer.error(err);
					});

			return () => subscription.unsubscribe();
		});
	}

	// params: corpo do DELETE (ex.: exclusão em lote). disableLoanding: suprime o
	// loading-screen.interceptor global -- usado por telas que já têm spinner próprio.
	public remove(id: string, params: any = null, disableLoanding = false): Observable<Response> {
		return new Observable<any>((observer) => {
			const opt = {
				context: new HttpContext().set(BYPASS_LOG, disableLoanding),
				body: JSON.stringify(params),
			};
			const subscription = this.http
				.delete(this.getEndpoint(id), opt)
				.pipe(map((response) => response))
				.subscribe((response) => {
					observer.next(response);
					observer.complete();
				},
					(err) => {
						observer.error(err);
					});

			return () => subscription.unsubscribe();
		});
	}

	public convertTimes(object: any) {
		Object.keys(object).forEach((e) => {
			const isDate = object[e] instanceof Date;
			if (isDate) {
				object[e] = object[e].toLocaleString();
			}
		});
	}

	private getEndpoint(path: string, baseUrl?: string): string {
		return `${baseUrl ? baseUrl : this.baseUrl}/${path}`;
	}
}
